import styled, { css } from 'styled-components';
import { breakpoint, breakpointMap, theme } from '../../../theme';
import { Heading, StyledHeadingProps } from '../../typography';
import { StyledContentCardProps } from './ContentCard';

const { spacings } = theme;

export const ContentCardTitle = styled(Heading)<
  Pick<StyledHeadingProps, 'size'> & {
    cardSize: StyledContentCardProps['size'];
  }
>`
  text-align: center;
  padding-top: ${spacings[3].rem};
  padding-bottom: ${spacings[1].rem};

  ${({ cardSize, size: headingSize }) =>
    breakpointMap(cardSize, (size) =>
      size === 'small'
        ? css`
            ${theme.typography.body.lg};
            font-weight: bold;
          `
        : css`
            ${breakpoint('lg')`
              ${theme.typography.headings[headingSize]['xl']}
            `};
          `
    )};
`;
